export const getCachedItem = (key) => {
  if (typeof window !== 'undefined') {
    const item = localStorage.getItem(key);

    if (item) {
      const now = new Date();
      try {
        const itemObj = JSON.parse(item);
        if (itemObj.data && itemObj.expiry > now.getTime()) {
          return JSON.parse(item)?.data;
        } else {
          return null;
        }
      } catch (e) {
        return null;
      }
    } else return null;
  } else return null;
};

export const setCachedItem = (key, data) => {
  const now = new Date();
  const cacheItem = {
    expiry: now.getTime() + 3600000,
    data: data,
  };

  localStorage.setItem(key, JSON.stringify(cacheItem));
};
